import { api } from "@/builders/axios";
import { ChaptersList, CreateChapter } from "@/builders/types/chapters";
import { id } from "./id";

type Params = {
  page?: number;
  department?: number;
  course?: number;
};

const get = function (params: Params = {}) {
  return api.get<ChaptersList>("chapters", { params }).then(({ data }) => data);
};

const post = function (data: CreateChapter) {
  return api.post("chapters", data);
};

export const chapters = {
  get,
  post,
  id,
};
